import { RequestService } from '../../../../core/services/request.service';
import { Nomenclature } from '../../../../shared/models/nomenclature';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormControl,
  FormArray,
  FormGroup,
  Validators,
  FormBuilder
} from '@angular/forms';

import { CustomValidators } from 'ngx-custom-validators';

import { FormErrorsService } from 'src/app/core/services/form-errors.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormGroupService } from 'src/app/core/services/form-group.service';
import { egnValidator } from 'src/app/shared/validators/egn.validator';
import { cyrillicTextValidator } from 'src/app/shared/validators/cyrillic-text.validator';
import { IdCardSides } from 'src/app/shared/enums/id-card-sides.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog, MatStepper } from '@angular/material';



@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {
  @ViewChild('stepper', { static: false }) stepper: MatStepper;

  eIdCardSides = IdCardSides;
  test: IdCardSides = IdCardSides.Back;
  // Форм групи
  loanFormGroup: FormGroup;
  idCardImagesFormGroup: FormGroup;
  idCardFormGroup: FormGroup;
  currentStatusFormGroup: FormGroup;
  contactsFormGroup: FormGroup;
  workFormGroup: FormGroup;
  incomeFormGroup: FormGroup;
  expensesFormGroup: FormGroup;
  guarantorsFormGroup: FormGroup;
  othersFormGroup: FormGroup;

  payments = new Map<number, number>();

  //Номенклатури
  loanTypesNomenclature$: Observable<Nomenclature[]>;
  loanAmountsNomenclature$: Observable<Nomenclature[]>;
  loanMonthsNomenclature$: Observable<Nomenclature[]>;
  ownershipOfPropertyNomenclature$: Observable<Nomenclature[]>;
  educationNomenclature$: Observable<Nomenclature[]>;
  employmentNomenclature$: Observable<Nomenclature[]>;
  workExperienceNomenclature$: Observable<Nomenclature[]>;
  areasOfOperationNomenclature$: Observable<Nomenclature[]>;
  employmentContractsNomenclature$: Observable<Nomenclature[]>;
  jobPositionsNomenclature$: Observable<Nomenclature[]>;

  constructor(
    private requestService: RequestService,
    private formGroupService: FormGroupService,
    private formBuilder: FormBuilder,
    private formErrorsService: FormErrorsService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {
    this.loanTypesNomenclature$ = this.requestService.getLoanTypesNomenclature();
    this.ownershipOfPropertyNomenclature$ = this.requestService.getOwnershipOfPropertyNomenclature();
    this.educationNomenclature$ = this.requestService.getEducationNomenclature();
    this.employmentNomenclature$ = this.requestService.getEmploymentNomenclature();
    this.workExperienceNomenclature$ = this.requestService.getWorkExperienceNomenclature();
    this.areasOfOperationNomenclature$ = this.requestService.getAreasOfOperationNomenclature();
    this.employmentContractsNomenclature$ = this.requestService.getEmploymentContractsNomenclature();
    this.jobPositionsNomenclature$ = this.requestService.getJobPositionsNomenclature();

  }


  test12() {
    console.log('date', this.idCardFormGroup.value);

  }
  sendRequest() {

    const x = this.idCardFormGroup.get('issuedOn').value;

    let hoursDiff = x.getHours() - x.getTimezoneOffset() / 60;
    let minutesDiff = (x.getHours() - x.getTimezoneOffset()) % 60;
    x.setHours(hoursDiff);
    x.setMinutes(minutesDiff);

    this.idCardFormGroup.get('issuedOn').setValue(x);

    const data = JSON.stringify({
      // Данни за заем
      loan: this.loanFormGroup.value,
      // Лична карта
      idCard: this.idCardFormGroup.value,

      //Снимки на личната карта
      idCardsPhotos: this.idCardImagesFormGroup.value,
      // Текущ статус
      currentStatus: this.currentStatusFormGroup.value,
      work: this.workFormGroup.value,
      // Контакти
      contacts: this.contactsFormGroup.value,
      // Приходи
      income: this.incomeFormGroup.value,
      // Разходи
      expenses: this.expensesFormGroup.value,
      // Поръчители
      guarantors: this.guarantorsFormGroup.value,
      // Други
      other: this.othersFormGroup.value
    });

    this.requestService.saveData(data).then(() => {
      this.openSnackBar('Вие успешно изпратихте молбата за заем към офиса успешно.', 'Затвори')
      console.log("Document successfully written!");
      console.log(data);
    })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });;;
  }

  get isFormValid() {

    if (this.loanFormGroup.valid &&
      this.idCardFormGroup.valid &&
      this.idCardImagesFormGroup.valid &&
      this.currentStatusFormGroup.valid &&
      this.workFormGroup.valid &&
      this.contactsFormGroup.valid &&
      this.incomeFormGroup.valid &&
      this.expensesFormGroup.valid &&
      this.guarantorsFormGroup.valid &&
      this.othersFormGroup.valid) {


      return true;
    }

    return false;
  }

  ngOnInit() {


    /** Формгрупа за информация за кредита */

    //TODO Да се направи с listner в кода,а  не по методите (valueChanges)
    this.loanFormGroup = this.formBuilder.group({
      loanType: [null, Validators.required],
      loanAmount: [null, Validators.required],
      loanMonths: [null, Validators.required],
      payment: [{ value: '', disabled: true }],
//      loanNo: ['', Validators.required],
      reason: ['']
    });

    /** Формгрупа за снимки на личната карта */
    this.idCardImagesFormGroup = this.formBuilder.group({
      front: [null],
      back: [null],
    });

    /** Формгрупа за лична карта */
    this.idCardFormGroup = this.formBuilder.group({
      egn: ['', [Validators.required, egnValidator(), CustomValidators.digits]],
      firstName: ['', [Validators.required, Validators.minLength(3), cyrillicTextValidator()]],
      surname: ['', [Validators.required, Validators.minLength(3), cyrillicTextValidator()]],
      lastName: ['', [Validators.required, Validators.minLength(3), cyrillicTextValidator()]],
      idCardNo: ['', Validators.required],
      issuedOn: ['', Validators.required],
      mvr: ['', [Validators.required, Validators.minLength(3), cyrillicTextValidator()]],
    });




    /** Формгрупа за социален статус */
    this.currentStatusFormGroup = this.formBuilder.group({
      household: ['', Validators.required],
      education: ['', Validators.required],
      memberOfHousehold: [
        '',
        [Validators.required, CustomValidators.range([1, 20])]
      ],
      childrenUnder18: ['', [Validators.required, CustomValidators.range([0, 20])]],
      employment: ['', Validators.required],
      workExperience: ['', Validators.required],
      address: this.formGroupService.buildAddressForm()
    });

    /** Формгрупа за контакти */
    this.contactsFormGroup = this.formBuilder.group({
      mobileCode: ['', [Validators.required, CustomValidators.digits]],
      mobile: ['', [Validators.required, CustomValidators.digits]],
      businessPhoneCode: ['', CustomValidators.digits],
      businessPhone: ['', CustomValidators.digits],
      homePhoneCode: ['', CustomValidators.digits],
      homePhone: ['', CustomValidators.digits],
      email: ['', [Validators.required, CustomValidators.email]],
      contactPersons: this.formBuilder.array([
        this.formGroupService.createContactPersonItem()
      ])
    });

    /** Формгрупа за работно място */
    this.workFormGroup = this.formBuilder.group({
      employer: ['', Validators.required],
      areaOfOperation: ['', Validators.required],
      vatNumber: [''],
      employees: ['', [CustomValidators.range([1, 2000])]],
      contractType: ['', Validators.required],
      position: ['', Validators.required],
      internshipInTheOrganization: ['', Validators.required],
      salaryDay: ['', [Validators.required, CustomValidators.range([1, 31])]],
      phoneNumber: ['']
    });

    /** Формгрупа за приходи */
    this.incomeFormGroup = this.formBuilder.group({
      salary: ['', CustomValidators.gte(0)],
      partnerSalary: ['', CustomValidators.gte(0)],
      additionalRevenue: ['', CustomValidators.gte(0)],
      childBenefits: ['', CustomValidators.gte(0)],
      rentalIncome: ['', CustomValidators.gte(0)],
      otherIncome: this.formBuilder.array([
        // this.formGroupService.createOtherIncomeItem()
      ])
    });
    /** Формгрупа за разходи */
    this.expensesFormGroup = this.formBuilder.group({
      electricityАndWater: ['', CustomValidators.gte(0)],
      internetAndTVandPhone: ['', CustomValidators.gte(0)],
      monthlyЕxpences: ['', CustomValidators.gte(0)],
      rent: ['', CustomValidators.gte(0)],
      childМaintenance: ['', CustomValidators.gte(0)],
      otherExpenses: ['', CustomValidators.gte(0)],
      otherCredits: this.formBuilder.array([
        // this.formGroupService.createOtherCreditItem()
      ])
    });

    //** Формгрупа за поръчители */
    this.guarantorsFormGroup = this.formBuilder.group({
      guarantors: this.formBuilder.array([])
    });

    this.othersFormGroup = this.formBuilder.group({
      fullName: ['', [Validators.minLength(3), cyrillicTextValidator()]],
      egn: ['', [egnValidator(), CustomValidators.digits]],
      phoneCode: ['', CustomValidators.digits],
      phone: ['', CustomValidators.digits],
      iban: [''],
      insurance: [false],
      howDoYouKnowAboutUs: [''],
      notes: [''],
      discretCredit: [false]
    });
  }

  /**
   * По тип на кредит се определят какви да са вноските.
   * @param event тип кредит
   */
  changeLoanType(event: string) {
    this.loanAmountsNomenclature$ = this.requestService.getLoanAmountsNomenclature(
      event
    );

    this.loanFormGroup.get('loanAmount').setValue(null);
    this.loanFormGroup.get('loanMonths').setValue(null);
  }

  /**
   * По тип кредит и сума се определят допустимите периоди (месеци)
   * @param loanType  тип кредит
   * @param amount  сума
   */
  changeLoanAmount(loanType: number, amount: number) {
    this.payments.clear();
    this.loanMonthsNomenclature$ = this.requestService
      .getLoanMonthsNomenclature(loanType, amount)
      .pipe(
        map(nom =>
          nom.periods.map(element => {
            this.payments.set(element.period, element.sum);
            return {
              id: element.period,
              name: element.period + ' ' + this.getPeriodText(loanType, element.period)
            };
          })
        )
      );
  }

  private getPeriodText(loanType: number, period: number): string {
    let str = 'месеца';
    if (5 === loanType) {
      if (5 === period) {
        str = 'седмица';
      } else {
        str = 'седмици';
      }
    }

    if (1 === period) {
      str = 'месец';
    }

    return str;
  }

  /**
   * Определя колко е вноската
   * @param months  месеци
   */
  changeLoanMonths(months: number) {
    this.loanFormGroup
      .get('payment')
      .setValue(this.payments.get(months) + ' лв.');
  }

  /**
   * Копира адреса на друго място
   * @param months  месеци
   */
  onChange(event) {
    const addressByIdCard = this.idCardFormGroup.get('address') as FormGroup;
    if (event.checked) {
      Object.keys(addressByIdCard.controls).forEach(key => {
        this.currentStatusFormGroup
          .get('address')
          .get(key)
          .setValue(this.idCardFormGroup.get('address').get(key).value);
      });
    } else {
      Object.keys(addressByIdCard.controls).forEach(key => {
        this.currentStatusFormGroup
          .get('address')
          .get(key)
          .setValue(null);
      });
    }
  }
  /** Добавяне на човек за контакти */
  addContactPersonItem(): void {
    this.contactPersons.push(this.formGroupService.createContactPersonItem());
  }

  /** Премахване на човек за контакти */
  removeContactPersonItem(index: number): void {
    this.contactPersons.removeAt(index);
  }
  /** Списък с хора */
  get contactPersons() {
    return this.contactsFormGroup.get('contactPersons') as FormArray;
  }

  addOtherIncomeItem() {
    this.otherIncome.push(this.formGroupService.createOtherIncomeItem());
  }

  removeOtherIncomeItem(index: number): void {
    this.otherIncome.removeAt(index);
  }

  get otherIncome() {
    return this.incomeFormGroup.get('otherIncome') as FormArray;
  }

  get otherCredits() {
    return this.expensesFormGroup.get('otherCredits') as FormArray;
  }

  addOtherCreditItem() {
    this.otherCredits.push(this.formGroupService.createOtherCreditItem());
  }

  removeOtherCreditItem(index: number) {
    this.otherCredits.removeAt(index);
  }

  get guarantors() {
    return this.guarantorsFormGroup.get('guarantors') as FormArray;
  }

  addGuarantorItem(): void {
    this.guarantors.push(this.formGroupService.createGuarantorItem());
  }

  removeGuarantorItem(index: number): void {
    this.guarantors.removeAt(index);
  }

  /** Визуализира грешката */
  public getError(fc: FormControl) {
    return this.formErrorsService.getErrorMessages(fc);
  }

  updateIdCardImageFormGroup(event: any) {

    switch (event.side) {

      case IdCardSides.Front:
        const front = this.idCardImagesFormGroup.get('front');
        if (front.value) {
          this.requestService.deteleFile(front.value).subscribe();
        }
        //upload file
        front.setValue(event.url);
        console.log('front url', front.value);
        break;

      case IdCardSides.Back:
        const back = this.idCardImagesFormGroup.get('back');
        if (back.value) {
          this.requestService.deteleFile(front.value).subscribe();
        }

        //upload file
        back.setValue(event.url);
        console.log('back url', back.value);
        break;

      default:
        break;
    }

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 4000,
    });
  }

  confirmDialog(): void {
    const message = `Сигурни ли сте, че искате да анулирате заявката?`;

    const dialogData = new ConfirmDialogModel("Внимание", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.stepper.reset();
      }
    });
  }

}

